var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3938_2391)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.997,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9784 14.1857C14.1659 11.8513 11.7694 10.6794 8.78896 10.6701C5.96246 10.7912 3.69489 11.9631 1.98622 14.1857C0.994278 12.881 0.425918 11.4044 0.281144 9.75606C0.085297 6.73304 1.12241 4.23108 3.39247 2.2502C5.7574 0.394304 8.40582 -0.168194 11.3378 0.5627C14.1543 1.42212 16.1054 3.22095 17.1913 5.95918C18.1275 8.7507 17.8111 11.3874 16.2421 13.8693C16.159 13.9815 16.0711 14.087 15.9784 14.1857Z",
    fill: "#E5EBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52581 2.79506C10.3037 2.70548 11.5283 3.47891 12.1996 5.11537C12.5815 6.55921 12.224 7.7838 11.1274 8.7892C9.94525 9.65844 8.69137 9.77561 7.36566 9.14076C6.08288 8.3624 5.5028 7.21983 5.62542 5.71303C5.96574 4.11296 6.93253 3.1403 8.52581 2.79506Z",
    fill: "#4294FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9785 14.1855C14.9819 15.5684 13.6812 16.5528 12.0762 17.1387C12.004 17.1352 11.9454 17.1587 11.9004 17.209C10.7102 17.6399 9.47978 17.7981 8.20898 17.6836C7.86329 17.6585 7.52344 17.6058 7.18945 17.5254C7.10726 17.4713 7.0135 17.4478 6.9082 17.4551C5.50048 17.1322 4.27001 16.4877 3.2168 15.5215C3.1672 15.4366 3.09689 15.378 3.00586 15.3457C2.60814 15.0054 2.2683 14.6187 1.98633 14.1855C3.69499 11.9629 5.96257 10.791 8.78906 10.6699C11.7695 10.6792 14.166 11.8511 15.9785 14.1855Z",
    fill: "#4394FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.961,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.00586 15.3457C3.09689 15.378 3.1672 15.4366 3.2168 15.5215C3.12577 15.4892 3.05546 15.4306 3.00586 15.3457Z",
    fill: "#95BEFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.345,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0762 17.139C12.0312 17.1893 11.9726 17.2128 11.9004 17.2093C11.9454 17.159 12.004 17.1356 12.0762 17.139Z",
    fill: "#A6C8FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.839,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.9082 17.4554C7.0135 17.4481 7.10726 17.4716 7.18945 17.5257C7.08652 17.5234 6.99275 17.5 6.9082 17.4554Z",
    fill: "#8AB8FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3938_2391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.838a9d94932a76ab64d4126b1cf81552.svg";
export { ForwardRef as ReactComponent };